import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import getPrivilegeList from "./PrivilegeList.jsx";

const CreditUnderwriting = () => {
  const navigate = useNavigate();
  const privilegeList = getPrivilegeList();
  const [customerId, setCustomerId] = useState("");
  const [loanId, setLoanId] = useState("");
  const [showRuleInputs, setShowRuleInputs] = useState(false);
  const [showSoftInputs, setShowSoftInputs] = useState(false);

  const handleRuleClick = () => {
    if (!showRuleInputs) {
      setShowRuleInputs(true);
      return;
    }
    if (!customerId || !loanId) {
      alert("Please enter both Customer ID and Loan ID");
      return;
    }
    navigate(`/RuleEngine?customerId=${customerId}&loanId=${loanId}`);
  };

  const handleSoftApprovalClick = () => {
    if (!showSoftInputs) {
      setShowSoftInputs(true);
      return;
    }
    if (!customerId || !loanId) {
      alert("Please enter both Customer ID and Loan ID");
      return;
    }
    navigate(`/SoftApprovalList?customerId=${customerId}&loanId=${loanId}`);
  };

  const handleBreClick = () => {
    navigate("/BreRulesList");
  };

  return (
    <div className="container mt-4">
      <h4 className="mb-3">Credit Underwriting</h4>

      <div className="row">
        {/* Rule Engine Box */}
        <div className="col-md-3">
          <div className="card shadow-sm">
            <div className="card-body text-center">
              <h6 className="text-uppercase text-muted mb-2">Rule Engine</h6>
              {!showRuleInputs ? (
                <span
                  className="btn btn-outline-primary btn-sm"
                  style={{ cursor: "pointer" }}
                  onClick={handleRuleClick}
                >
                  View
                </span>
              ) : (
                <div>
                  <input
                    type="text"
                    className="form-control mb-2"
                    placeholder="Customer ID"
                    value={customerId}
                    onChange={(e) => setCustomerId(e.target.value)}
                  />
                  <input
                    type="text"
                    className="form-control mb-2"
                    placeholder="Loan ID"
                    value={loanId}
                    onChange={(e) => setLoanId(e.target.value)}
                  />
                  <button
                    className="btn btn-outline-primary btn-sm"
                    onClick={handleRuleClick}
                  >
                    Go to Rule Engine
                  </button>
                </div>
              )}
            </div>
          </div>
        </div>

        {/* BRE Rules Box */}
        {privilegeList.pedayBreView && (
        <div className="col-md-3">
          <div className="card shadow-sm">
            <div className="card-body text-center">
              <h6 className="text-uppercase text-muted mb-2">Paday BRE Rules</h6>
              <button
                className="btn btn-outline-primary btn-sm"
                onClick={handleBreClick}
              >
                View
              </button>
            </div>
          </div>
        </div>
        )}

        {/* BRE Rules Agent Box */}
        {privilegeList.agentBreView && (
        <div className="col-md-3">
          <div className="card shadow-sm">
            <div className="card-body text-center">
              <h6 className="text-uppercase text-muted mb-2">EDI BRE Rules</h6>
              <button
                className="btn btn-outline-primary btn-sm"
                onClick={() => navigate("/BreRulesAgentList")}
              >
                View
              </button>
            </div>
          </div>
        </div>
        )}

        {/* Finance BRE Rules Box */}
        {privilegeList.financeBreView && (
        <div className="col-md-3">
          <div className="card shadow-sm">
            <div className="card-body text-center">
              <h6 className="text-uppercase text-muted mb-2">Finance BRE Rules</h6>
              <button
                className="btn btn-outline-primary btn-sm"
                onClick={() => navigate("/BreRulesFinanceList")}
              >
                View
              </button>
            </div>
          </div>
        </div>
        )}

        {/* Soft Approval Box */}
        {privilegeList.softApprovalView && (
        <div className="col-md-3">
          <div className="card shadow-sm">
            <div className="card-body text-center">
              <h6 className="text-uppercase text-muted mb-2">Soft Approval</h6>
              {!showSoftInputs ? (
                <span
                  className="btn btn-outline-primary btn-sm"
                  style={{ cursor: "pointer" }}
                  onClick={handleSoftApprovalClick}
                >
                  View
                </span>
              ) : (
                <div>
                  <input
                    type="text"
                    className="form-control mb-2"
                    placeholder="Customer ID (optional)"
                    value={customerId}
                    onChange={(e) => setCustomerId(e.target.value)}
                  />
                  <input
                    type="text"
                    className="form-control mb-2"
                    placeholder="Loan ID (optional)"
                    value={loanId}
                    onChange={(e) => setLoanId(e.target.value)}
                  />
                  <button
                    className="btn btn-outline-primary btn-sm"
                    onClick={() => {
                      const query = [];
                      if (customerId) query.push(`customerId=${customerId}`);
                      if (loanId) query.push(`loanId=${loanId}`);
                      const queryString = query.length ? `?${query.join("&")}` : "";
                      navigate(`/SoftApprovalList${queryString}`);
                    }}
                  >
                    Go to Soft Approval
                  </button>
                </div>
              )}
            </div>
          </div>
        </div>
        )}
      </div>
    </div>
  );
};

export default CreditUnderwriting;
